import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface ClientProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function Client({ color = RoutalPalette.secondary60, style = {} }: ClientProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" style={{ height: `16px`, width: `16px`, ...style }}>
      <g>
        <path
          fill={color}
          fillRule="evenodd"
          strokeWidth="0px"
          d="M6,.12C3.01.12.59,2.55.59,5.54c0,1.65.74,3.14,1.92,4.14.16.14.33.27.5.38.03.02.05.03.08.05.82.53,1.62.7,1.63.68.07.04.22.24.31.36.27.35.55.72.98.72.1,0,.19-.02.27-.06.28-.12.5-.39.7-.66.03-.04.07-.09.11-.15.08-.1.16-.19.18-.21.1-.02.42-.1.85-.28.02,0,.04-.02.06-.03.24-.1.49-.23.75-.4,0,0,.02-.01.03-.02.21-.13.41-.28.61-.46,0,0,0,0,0,0,1.14-1,1.84-2.46,1.84-4.07C11.41,2.55,8.99.12,6,.12ZM9.92,7.55c-.17-.4-.45-.77-.82-1.03-.51-.36-1.02-.52-1.56-.59-.38.42-.93.69-1.54.69s-1.16-.27-1.54-.69c-.54.07-1.05.23-1.56.59-.37.26-.65.63-.82,1.03-.31-.61-.49-1.29-.49-2.02C1.59,3.1,3.57,1.12,6,1.12s4.41,1.98,4.41,4.41c0,.72-.18,1.41-.49,2.02Z"
        />
        <path
          fill={color}
          fillRule="evenodd"
          strokeWidth="0px"
          d="M6,2.86c-.92,0-1.67.75-1.67,1.67s.75,1.67,1.67,1.67,1.67-.75,1.67-1.67-.75-1.67-1.67-1.67Z"
        />
      </g>
    </SvgIcon>
  );
}
